import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { TopBar } from "@/components/TopBar";
import { PayPalButton } from "@/components/PayPalButton";
import { PawPrint } from "lucide-react";

export default function CustomerDashboard() {
  const { t, user } = useApp();
  const nav = useNavigate();
  const [horses, setHorses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/horses").then((r) => setHorses(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen pb-28">
      <TopBar showLogout />
      <div className="mx-auto max-w-5xl px-4 py-10 sm:px-6">
        <p className="text-sm uppercase tracking-[0.2em] text-primary">{t("welcome")}</p>
        <h1 className="mt-1 font-serif-h text-3xl text-foreground" data-testid="customer-greeting">{user?.name}</h1>

        <h2 className="mt-10 font-serif-h text-2xl text-foreground">{t("my_horses")}</h2>
        {loading ? (
          <p className="mt-6 text-muted-foreground">…</p>
        ) : horses.length === 0 ? (
          <p className="mt-6 rounded-[12px] border border-border bg-card p-6 text-muted-foreground" data-testid="no-horses">
            {t("no_horses")}
          </p>
        ) : (
          <div className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {horses.map((h) => (
              <button
                key={h.id}
                data-testid={`horse-card-${h.id}`}
                onClick={() => nav(`/horse/${h.id}`)}
                className="group rounded-[12px] border border-border bg-card p-6 text-left shadow-[0_4px_20px_rgba(62,97,72,0.04)] transition-transform hover:-translate-y-1 hover:shadow-[0_8px_30px_rgba(62,97,72,0.1)]"
              >
                <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-[#EAF0EB] text-primary">
                  <PawPrint className="h-6 w-6" strokeWidth={1.5} />
                </div>
                <div className="font-serif-h text-xl text-foreground">{h.name}</div>
                <div className="mt-2 text-sm text-muted-foreground">
                  {[h.breed, h.age && `${h.age}`].filter(Boolean).join(" · ") || "—"}
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
      <PayPalButton fixed />
    </div>
  );
}
